module.exports = __webpack_public_path__ + "img/top-list-left5.eed8a83c.png";